<script lang="ts" setup>
import type { EditorialDiscoverAlternative } from '@integration-layer/ampliance/schemas/editorial-discover-alternative-schema.localized'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialDiscoverAlternative
}>()

const data = await useComponentResponse<EditorialDiscoverAlternative>(props)

const transformedData: any = {
  ...data.value,
}
</script>

<template>
  <EditorialDiscoverAlternative v-bind="transformedData" />
</template>
